import { WorksheetResult, worksheetMessage } from './worksheet-service';
import { fetchRequest } from './';

const service = 'visittracking';
const method = 'post';

export interface VisitArgs {
  visitId: string;
  code?: string;
  description?: string;
  injuryState?: string;
}

interface VisitResult extends VisitArgs {
  createDate: Date;
  createWho: string;
}

export type VisitTrackingResult = WorksheetResult<VisitResult>;

export const addArrivalmodeRequest = fetchRequest<
  VisitArgs,
  VisitTrackingResult
>({
  method,
  body: (args: VisitArgs) => worksheetMessage(args, 'addarrivalmode', service),
});

export const addDispositionRequest = fetchRequest<
  VisitArgs,
  VisitTrackingResult
>({
  method,
  body: (args: VisitArgs) => worksheetMessage(args, 'adddisposition', service),
});

export const addInjuryRequest = fetchRequest<VisitArgs, VisitTrackingResult>({
  method,
  body: (args: VisitArgs) => worksheetMessage(args, 'addinjury', service),
});

export const deleteArrivalmodeRequest = fetchRequest<
  VisitArgs,
  VisitTrackingResult
>({
  method,
  body: (args: VisitArgs) => worksheetMessage(args, 'deletearrivalmode', service),
});

export const deleteDispositionRequest = fetchRequest<
  VisitArgs,
  VisitTrackingResult
>({
  method,
  body: (args: VisitArgs) => worksheetMessage(args, 'deletedisposition', service),
});

export const deleteInjuryRequest = fetchRequest<VisitArgs, VisitTrackingResult>({
  method,
  body: (args: VisitArgs) => worksheetMessage(args, 'deleteinjury', service),
});


interface VisitData {
  arrivalMode?: VisitResult;
  disposition?: VisitResult;
  injury?: VisitResult;
}

export type VisitTrackingListResult = WorksheetResult<VisitData>;
export const getVisitTrackingRequest = fetchRequest<
  VisitArgs,
  VisitTrackingListResult
>({
  method,
  body: (args: VisitArgs) => worksheetMessage(args, 'getTracking', service),
});
